import { put, take } from 'redux-saga/effects'
import { unAuthenticate } from '../../auth/actions/auth.types'
import { resetIncompleteListings } from '../actions/incomplete-listings.actions'

export default function*() {
  yield take(unAuthenticate)
  yield put(resetIncompleteListings())
}
